import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { OpenTofuMigrationQueueEntryNode } from "shared/Stack/OpenTofuMigration/gql";

const OpenTofuMigrationQueueTableLastUpdateCell = ({
  item: entry,
  ...cellProps
}: TableSimpleCellProps<OpenTofuMigrationQueueEntryNode>) => (
  <TableSimpleCell {...cellProps}>
    <Timestamp timestamp={entry.updatedAt} variant="p-body3" />
  </TableSimpleCell>
);

export default OpenTofuMigrationQueueTableLastUpdateCell;
